export default __webpack_public_path__ + "resources/icons/n331-5c8b.png";